import { useCallback, useState } from "react";
import { z } from "zod";

import type * as Type from "./type";
import type * as Repository from "../../_repository";

type Props = {
	option: Repository.Query.QueryData.OptionPmsList.Option;
};

export const useViewModel = ({ option }: Props) => {
	const [viewModel, setViewModel] = useState<Type.ViewModel>({
		memo: {
			value: option.memo ?? "",
			isEdited: false,
			error: undefined,
		},
	});
	/**
	 * メモの変更
	 */
	const onChangeMemo = useCallback((value: string) => {
		const memoZodValidation = z.string().max(1_000, "メモは100文字以内で入力してください");

		const result = memoZodValidation.safeParse(value);

		if (result.success) {
			setViewModel((prev) => ({ ...prev, memo: { value, isEdited: true, error: undefined } }));
		} else {
			const errorMessage = result.error.errors[0].message;
			setViewModel((prev) => ({ ...prev, memo: { value, isEdited: true, error: errorMessage } }));
		}
	}, []);

	return {
		//
		viewModel,
		//
		// メモの変更
		onChangeMemo,
	};
};
